import React from 'react';

import { HiringPaywall } from '@/components/tier-lite';

export default function HiringPaywallPage() {
  return <HiringPaywall />;
}
